import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import descriptionStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.jsx";

function SectionDescription(props) {
  const { classes } = props;
  return (
    <div className={classNames(classes.aboutDescription)}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <h2 className={classes.description, classes.textCenter}>
            NEW PROPERTY EXPERTS
          </h2>

          <h3>Kinos brings a modern approach to new development marketing and sales.</h3>

          <h5>
            From boutique rental conversions to luxurious ground-up condominiums, browse our portfolio of current offerings.
            Kinos from 2003 year has become recognised as one of the leading property firms on the Costa del Sol when it comes to the marketing, promotion and sales of new-build and off plan property developments.
            New Home and Residential Sales
            Our Residential/New Homes team advises on buying and selling opportunities to both owner occupiers and investors looking to acquire apartments within new residential developments at Spain.
          </h5>

          <h5>
            We undertake consultancy work for major house-builders and work with vendor's to establish the most suitable marketing strategy and pricing package for individual developments and units.
            A complete ‘On and Off line’ marketing service for builders & property developers.
          </h5>

        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(descriptionStyle)(SectionDescription);
